// https://stackoverflow.com/questions/52677576/typescript-discriminated-union-allows-invalid-state/52678379#52678379
type UnionKeys<T> = T extends any ? keyof T : never;
type StrictUnionHelper<T, TAll> = T extends any
  ? T & Partial<Record<Exclude<UnionKeys<TAll>, keyof T>, never>>
  : never;
export type StrictUnion<T> = StrictUnionHelper<T, T>;

export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;

export type Values<T extends object> = T[keyof T];

export type SubType<Base, Condition> = Pick<
  Base,
  { [Key in keyof Base]: Base[Key] extends Condition ? Key : never }[keyof Base]
>;

export type PartialOnKeys<Base, Keys> = Omit<Base, Keys> & Partial<Base>;
export type PartialOnAllButKeys<Base, Keys extends keyof Base> = Partial<Omit<Base, Keys>> &
  Pick<Base, Keys>;

export type Diff<T, U> = T extends U ? never : T;
export function isDefined<T>(arg: T | undefined): arg is T {
  return typeof arg !== 'undefined';
}

export function isNotNull<C>(c: C): c is Diff<C, null> {
  return c !== null;
}

export function isNotNullOrUndefined<TValue>(value: TValue | null | undefined): value is TValue {
  if (value === null || value === undefined) return false;
  return true;
}

export function isKeyOf<T extends object>(obj: T, key: string | number | symbol): key is keyof T {
  return key in obj;
}

export function objectEntries<T extends object>(a: T) {
  return Object.entries(a) as [keyof T, T[keyof T]][];
}

export function objectKeys<T extends object>(a: T) {
  return Object.entries(a) as [keyof T, T[keyof T]][];
}

export type NonNullable<T> = Diff<T, null | undefined>;

export type ReplaceProps<T, R> = Pick<T, Exclude<keyof T, keyof R>> & R;
export type AnyTypename<T> = ReplaceProps<T, { __typename?: any }>;

export type ArgsType<T> = T extends (...args: infer U) => any ? U : never;

// tslint:disable no-shadowed-variable
export type Unpacked<T> = T extends (infer U)[]
  ? U
  : T extends (...args: any[]) => infer U
  ? U
  : T extends Promise<infer U>
  ? U
  : T;
// tslint:enable no-shadowed-variable

export type ResponseOf<T extends (...args: any) => Promise<any>> = Unpacked<ReturnType<T>>;

// For use with exhaustive checks
export class UnreachableCaseError extends Error {
  constructor(val: never) {
    super(`Unreachable case: ${val}`);
  }
}

export type TSFixMe = any;

export interface WithGraphQL {
  graphql: void;
}

export type WithTypename<T> = T & { __typename: string };

export type Writeable<T> = { -readonly [P in keyof T]: T[P] };
